/**
 * LoopNest Media Provider — Pixabay
 * Requires VITE_PIXABAY_API_KEY environment variable
 * License: Pixabay License (CC0-equivalent, free for commercial use)
 * https://pixabay.com/service/license-summary/
 */

import { BaseMediaProvider, LICENSE_TYPES, createMediaItem } from './baseProvider';

export class PixabayProvider extends BaseMediaProvider {
  constructor() {
    super({
      id: 'pixabay-cc0',
      label: 'Pixabay',
      license: LICENSE_TYPES?.PIXABAY,
      requiresAttribution: false,
      baseUrl: 'https://pixabay.com/api',
      enabled: !!import.meta.env?.VITE_PIXABAY_API_KEY,
    });
    this.apiKey = import.meta.env?.VITE_PIXABAY_API_KEY || null;
  }

  async search(query, options = {}) {
    if (!this.apiKey) {
      console.warn('[PixabayProvider] No API key configured. Set VITE_PIXABAY_API_KEY.');
      return [];
    }
    const { count = 5 } = options;
    try {
      const res = await fetch(
        `${this.baseUrl}/?key=${this.apiKey}&q=${encodeURIComponent(query)}&image_type=photo&orientation=horizontal&per_page=${count}&safesearch=true`
      );
      if (!res?.ok) return [];
      const data = await res?.json();
      return (data?.hits || [])?.map((hit) =>
        createMediaItem({
          id: `pixabay-${hit?.id}`,
          url: hit?.largeImageURL || hit?.webformatURL,
          previewUrl: hit?.previewURL || hit?.webformatURL,
          alt: hit?.tags || query,
          author: hit?.user,
          providerId: this.id,
          license: this.license,
          requiresAttribution: this.requiresAttribution,
          width: hit?.imageWidth,
          height: hit?.imageHeight,
        })
      );
    } catch (err) {
      console.warn('[PixabayProvider] Search failed:', err);
      return [];
    }
  }
}

export const pixabayProvider = new PixabayProvider();
